<template>
  <div class="wrapper">
    <release-note-modal ref="release-note-modal" style="z-index: 10000" />
    <div style="z-index: 100; position: absolute;width: 100vw;text-align: right;color: #e74a23;font-size: 5vh;padding: 2vh 4vh 0 0">
      <span class="top-header-icon" @click="openReleaseNote">chat</span>
    </div>
    <div id="ring"></div>
    <div id="header">
      <img src="https://storage.googleapis.com/wcam-27caf.appspot.com/public/logo500.png" class="logo">
    </div>
    <div class="tabs">
      <div class="tab-button noto300" :class="currentTab === tabs[0] ? 'active' : ''" @click="onTabClicked(0)">
        <span class="material-icons-outlined">directions_run</span>
        ゲーム&運動
      </div>
      <div class="tab-button noto300" :class="currentTab === tabs[1] ? 'active' : ''" @click="onTabClicked(1)">
        <span class="material-icons-outlined">build</span>
        ツール
      </div>
    </div>
    <div class="cards">
      <div v-for="content in tabContents" class="card-group">
        <a
           class="card" :class="{disabled: content.config.noAccess}"
           :href="content.config.noAccess ? '#' : `./${content.id}`"
           :key="content.id"
           :style="{ background: `url('${content.url}')`, 'background-size': 'contain'}">
          <div v-if="content.tags" class="content-tags" v-show="!isMobile">
            <div v-for="tag in content.tags" :key="tag" class="content-tag">{{tag}}</div>
          </div>
          <div class="content-title noto500">
            <div>
              {{content.title}}
            </div>
            <div v-show="!isMobile" class="content-desc noto500">
              {{content.config.desc}}
            </div>
          </div>
        </a>
        <div v-show="isMobile" class="mobile-desc">
          {{content.config.desc}}
        </div>
      </div>
    </div>
    <div>
      <basic-button @click="goAnotherTab" :label="currentTab === tabs[0] ? 'ツールも見る' : 'ゲームも見る'"/>
    </div>

    <div>
      <div>
        <basic-button label="シェア" @click="tweet">
          <svg viewBox="0 0 32 32" style="fill: white;width: 3vh;height: 3vh;margin-bottom: -0.5vh">
            <path d="M2 4c4 4 8 8 13 7a6 6 0 0 1 7-7 6 6 0 0 1 4 2 8 8 0 0 0 5-2 8 8 0 0 1-3 4 8 8 0 0 0 4-1 8 8 0 0 1-4 4 18 18 0 0 1-18 19 18 18 0 0 1-10-3 12 12 0 0 0 8-3 8 8 0 0 1-5-4 8 8 0 0 0 3-.5A8 8 0 0 1 0 12a8 8 0 0 0 3 1 8 8 0 0 1-1-9"/>
          </svg>
        </basic-button>
      </div>
    </div>


    <common-footer :menu="{home:false,analytics:true}" />
  </div>
</template>

<script>
import * as THREE from 'three';
window.THREE = THREE
import RINGS from 'vanta/src/vanta.rings'
import CommonFooter from "./CommonFooter";
import {FitUtil} from "./common/FitUtil";
import BasicButton from "./common/BasicButton";
import ReleaseNoteModal from "./common/ReleaseNoteModal";

const TAB_ALL = 'all'
const TAB_GAME = 'game'
const TAB_TOOL = 'tool'
const TABS = [TAB_GAME, TAB_TOOL]
function createContents(id, title, config, tags) {
  let url = `https://storage.googleapis.com/wcam-27caf.appspot.com/public/thumb/${id}_thumb.png`
  if (config.status) {
    url = `https://storage.googleapis.com/wcam-27caf.appspot.com/public/thumb/${config.status}.jpg`
    if (config.status === 'wip' || config.status === 'wip1') {
      config.noAccess = true
    }
  }
  url += '?v=3'
  if (!tags) tags = []
  return {id, title, url, tags, config}
}
const contents = {
  [TAB_GAME]: [
    createContents('jogging', 'ジョギング', {desc:'その場ジョギングの時間や距離を計測',}),
    createContents('dumbbell-curl', 'ダンベル(カール)', {desc:'ダンベルを肩まで上げる運動',}, []),
    createContents('crunch', 'クランチ', {desc:'いわゆる腹筋運動みたいなやつ',}, []),
    createContents('squat', 'スクワット', {desc:'足腰を鍛える運動',}, []),
    createContents('seiken', '感謝の正拳突き', {desc:'毎日n回繰り返す正拳突き',}),
    createContents('shuttle-run', '20mシャトルラン', {status:'wip2', desc:'制限時間内に20m走る事を繰り返す体力テスト'}, ['beta']),
    createContents('youtube-jogging', 'YouTubeジョギング', {status:'wip1', desc:'走ってる間だけYouTubeが再生される'}),
    createContents('fly', 'とべ！', {status:'wip1', desc:'手をバタつかせて高度を調整するゲーム'}),
    createContents('tetris', '筋肉テトリス', {status:'wip1', desc:'左右パンチで左右移動、スクワットで回転'}),
  ],
  [TAB_TOOL]: [
    createContents('kamehameha', '必殺技1', {desc:'両手からビーム的なの出す系必殺技',}),
    createContents('rei-gun', '必殺技2', {desc:'指から丸い何か出す系必殺技',}, []),
    createContents('mustang', '指パッチン', {desc:'指パッチンしたら炎が出る'}, []),
    createContents('sandbag', 'サンドバッグ', {desc:'仮想サンドバッグ',status:'wip'}, []),
    createContents('glow-stick', 'サイリウム', {desc:'仮想サイリウム',status:'wip'}, []),
  ]
}
const title = 'WEB FIT'
const desc = '運動や筋トレを自動計測したり、身体を使うゲームで運動を継続させるツール'
const ogImg = 'https://storage.googleapis.com/wcam-27caf.appspot.com/public/ogp/screen_1200_628.png'
export default {
  head() {
    return {
      title: {
        inner: title,
      },
      meta: [
        { name: 'og:url', content: 'https://web-fit.work/' },
        { name: 'og:type', property: 'og:type', content: 'website' },
        { name: 'application-name', property: 'application-name', content: title },
        { itemprop: 'name', content: title },
        { name: 'og:title', property: 'og:title', content: title },
        { name: 'description', property: 'description', content: desc, id: 'desc' }, // id to replace intead of create element
        { itemprop: 'description', content: desc },
        { name: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', property: 'twitter:title', content: title },
        { name: 'twitter:description', property: 'twitter:description', content: desc},
        { name: 'og:image', property: 'og:image', content: ogImg },
        { name: 'twitter:image', property: 'twitter:image', content: ogImg },
      ],
    }
  },
  name: 'Top',
  components: {ReleaseNoteModal, BasicButton, CommonFooter},
  data () {
    return {
      currentTab: TAB_GAME,
      tabs: [TAB_GAME, TAB_TOOL],
      isMobile: FitUtil.isMobile(),
    }
  },
  computed: {
    tabContents() {
      if (this.currentTab === TAB_ALL) {
        return contents[TAB_GAME].concat(contents[TAB_TOOL])
      }
      return contents[this.currentTab]
    },
  },
  methods: {
    openReleaseNote() {
      this.$refs['release-note-modal'].$emit('open-modal')
    },
    onTabClicked(tabIndex) {
      this.currentTab = TABS[tabIndex]
    },
    goAnotherTab() {
      this.currentTab = this.currentTab === TAB_GAME ? TAB_TOOL : TAB_GAME
      window.scrollTo(0, 0)
    },
    tweet() {
      const s = `WEB-FIT`;
      const url = "http://twitter.com/share?url=" + escape(document.location.href) + "&text=" + s + "&hashtags=WEBFIT";
      window.open(url,"_blank","width=600,height=300");
    },
  },
  mounted() {
    RINGS({
      el: "#ring",
      scale: 1,
      scaleMobile: 1,
      backgroundColor: 'white',
      // color: '#e9671f'
    })
    // window.edit_page.Event.subscribe( "Page.beforeNewOneFadeIn", setVanta )
    // _strk.push(function() {
    // })
  }
}
</script>

<style>
html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
}
</style>
<style scoped>
#ring {
  position: absolute;
  top: 0;
  left: -10vw;
  width: 150vw;
  height: 50vh;
  z-index: -1;
}
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  overflow: hidden;
  height: auto;
}
.title {
  width: fit-content;
  font-weight: bold;
  font-size: 8vh;
  background: rgba(255,255,255,0.8);
}
@media (max-aspect-ratio: 1/1) {
  .title {
    font-size: 9vh;
  }
}
.desc {
  width: fit-content;
  font-weight: normal;
  font-size: 3vh;
  background: rgba(255,255,255,0.8);
  margin: 1vh 0;
}
.mobile-desc {
  font-size: 1.8vh;
  text-align: left;
  padding: 2vw 2vw;
  background: linear-gradient(200deg,#e74a23,#e9671f,#ec841b);
  color: white;
  margin: -1vh 1.5vh 1vh 1.5vh;
  border-radius: 4px;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.8);
}
#header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50vh;
  text-align: left;
  padding-top: 8vh;
  padding-left: 5vw;
  /*line-height: 70vh;*/
  /*border-bottom: 1px solid #ccc;*/
  /*background: white;*/
  /*font-family: 'Press Start 2P', cursive;*/
  font-family: 'Hubballi', cursive;
  font-weight: bold;
  font-size: 7vh;
}
.tabs {
  width: 100%;
  background: #f0f0f0;
  position: absolute;
  top: 45vh;
  padding-top: 8px;
  box-shadow: 4px 2px 2px rgba(0,0,0,0.2); /* コンテンツの上の影 */
}
.tab-button {
  cursor: pointer;
  margin-bottom: -4px; /* 影のため */
  display: inline-block;
  height: 7vh;
  width: 20vw;
  line-height: 7vh;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-family: 'Hubballi', cursive;
  font-size: 2.5vh;
  font-weight: bold;
  background: #ec841b;
  color: #fff;
  box-shadow: 4px -2px 4px rgba(0,0,0,0.15);
}
.tab-button.active {
  font-weight: bolder;
  background: white;
  color: #e9671f;
}

.top-header-icon {
  font-family: 'Material Icons';

  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48;
  cursor: pointer;
  display: inline-block;
  margin: 0 3vh 0 0;
}

.material-icons-outlined {
  vertical-align: middle;
  margin-top: -10px;
  display: inline-block;
  font-family: 'Material Icons';
  /*font-size: 3.5vh;*/
  pointer-events: none;
}
@media (max-aspect-ratio: 1/1) {
  .tab-button {
    width: 40vw;
  }
}

.cards {
  padding-top: 4vh;
  margin: 50vh auto auto auto;
  text-align: center;
  background: white;
  width: 90vw;
  /*background: red;*/
}
.card-group {
  width: 40vh;
  display: inline-block;
  margin: 3vh;
}
.card {
  position: relative;
  background-size: contain;
  display: inline-block;
  width: 40vh;
  height: 40vh;
  border: 6px solid #eee;
  /*margin: 3vh;*/
  border-radius: 20px;
  font-family: 'Hubballi', cursive;
  font-size: 4vh;
  text-decoration: none;
  color: black;
  overflow: hidden;
}
.card.disabled {
  pointer-events: none;
  cursor: default;
}
.content-title {
  border-bottom-right-radius: 2vh;
  border-bottom-left-radius: 2vh;
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  color: #fff;
  /*text-shadow: 1px 1px 1px rgb(233,103,31), 1px -1px 1px rgb(233,103,31), -1px 1px 1px rgb(233,103,31), -1px -1px 1px rgb(233,103,31);*/
  font-size: 3vh;
  line-height: 7vh;
  /*background: rgba(233,103,31,0.9);*/
  background: rgba(0,0,0,0.75);
  /*background: rgba(220,220,220,0.9);*/

  text-overflow: ellipsis;
  white-space: nowrap;
}
.content-desc {
  font-size: 1.8vh;
  line-height: 1;
  padding: 0 0 2vh 0;
}
.content-tags {
  position: absolute;
  top: 0;
  left: 0;
  margin: 1vh;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.content-tag {
  display: inline-block;
  font-size: 2vh;
  background: rgba(233,103,31,0.9);
  color: white;
  font-weight: bold;
  padding: 1vh 2vh;
  border-radius: 1.5vh;
  margin: 0.2vh;
}
.logo {
  height: 25vh
}
@media (max-aspect-ratio: 1/1) {
  .cards {
    margin-top: 45vh;
    padding-top: 1vh;
  }
  .tabs {
    top:35vh
  }
  #ring {
    left: -20vw;
    width: 120vw;
    height: 35vh;
  }
  #header {
    height: 35vh;
  }
  .logo {
    width: 90vw;
    background: rgba(255,255,255,0.8);
    height: auto;
    position: absolute;
    top: 5vh;
    left: 5vw;
    right: 5vw;
    padding-bottom: 2vh;
  }
}
@media (max-aspect-ratio: 1/1) {
  .card-group {
    margin: 0;
    padding: 0;
    width: 36vw;
    min-height: 20vh;
    vertical-align: top;
    /*max-height: 25vh;*/
    overflow: hidden;
  }
  .card {
    width: 33vw;
    height: 33vw;
    margin: 1vw;
    border: 4px solid #eee;
  }

  .content-title {
    font-size: 2vh;
    line-height: 5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue